var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgD2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 12.2105C23 9.74342 21.8938 7 20 7C18.1062 7 17 9.74342 17 12.2105C17 14.1842 17.8625 15.3882 19.0437 15.7829L18.4437 23.2237C18.3687 24.1908 19.1 25 20.0187 25C20.9375 25 21.65 24.1711 21.5938 23.2237L20.9562 15.7829C22.1375 15.3684 23 14.1645 23 12.2105Z",
    fill: "#D8D1CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2743 7.02034H14.214C13.8921 7.02034 13.6506 7.28471 13.6506 7.61009L13.7915 12.0841C13.8116 12.4094 13.55 12.6738 13.2281 12.6738C12.9263 12.6738 12.6648 12.4298 12.6648 12.1247L12.6245 7.56941C12.6245 7.26437 12.363 7.02034 12.0612 7.02034H11.9807C11.6789 7.02034 11.4174 7.26437 11.4174 7.56941L11.357 12.1044C11.357 12.4094 11.0955 12.6535 10.7937 12.6535C10.4718 12.6535 10.2303 12.3891 10.2303 12.0637L10.3712 7.58975C10.3913 7.26437 10.1297 7 9.80781 7H9.74746C9.44567 7 9.20423 7.24403 9.18411 7.54908L9.00304 12.1857C8.94268 13.5483 9.7877 14.7074 10.9949 15.1548L10.3108 23.1697C10.2303 24.1662 11.015 25 12.0008 25C12.9867 25 13.7512 24.1459 13.6909 23.1697L13.0068 15.1548C14.1938 14.7278 15.0389 13.5483 14.9986 12.1857L14.8377 7.56941C14.8175 7.26437 14.5761 7.02034 14.2743 7.02034Z",
    fill: "#D8D1CF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgD2);
export default __webpack_public_path__ + "static/media/d2.1fea5eb9d017d70296a4f7fa888d2564.svg";
export { ForwardRef as ReactComponent };